import { Flex, Heading } from "@chakra-ui/core"
import React from "reactn"
export const NotFound = () => (
  <Flex align="center" justify="center" borderWidth="1px" h="100%">
    <Heading>L'élément recherché n'a pas été trouvé dans la base.</Heading>
  </Flex>
)
